/**
* The route configuration names
*/
export const RouteDefinitionType = {
    'TransactionConfirmation': 't-confirmation',
    'TransactionFeesTaxes': 't-feesTaxes',
    'TransactionDefault': 't-default',
    'DriverFinalization': 't-driverfinalization',
    'IRPFinalization': 't-irpfinalization',
    'FinanceFinalization': 't-financefinalization',
    'CollectionsFinalization': 't-collectionsfinalization',
    'PaceFinalization': 't-pacefinalization',
    'CaseDefault': 't-caseDefault',
    'TnrFinalization': 't-tnrfinalization',
    'SpinnerLayout': 't-spinnerLayout',
    'CommercialPermittingFinalization': 't-permittingfinalization',
    'AircraftFinalization': 't-aircraftfinalization'
};
